export default "__VITE_ASSET__B5OMQQ2M__"